import Alpine from 'alpinejs'
import './rsvp.js'
import './admin.js'
import './share.js'

Alpine.start()
